import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './components/App';

const root = ReactDOM.createRoot(document.getElementById('edint-video-play-on-scroll-with-texts-overlay-video3'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);